import {REPORT_ENDPOINTS, USER_ENDPOINTS} from './endpoints';
import {fetchData} from "../../Utils/fetchData";
import authToken from "../../Utils/authToken";
import {ApiResponse} from "../../types/api.types";
import {SubUser} from "../models/sub_user";
import {IReport, IReportLogsResponse} from "../models/report";

export const ReportAPI = {
    fetchUsersByEmails: async (data: Record<string, string[]>): Promise<ApiResponse<SubUser[]>> => {
        const response = await fetchData(USER_ENDPOINTS.FETCH_USER_BY_EMAIL, {
            method: "POST",
            headers: {
                Authorization: authToken(),
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data)
        }, 2);

        return response.json();
    },
    upsert: async (data: IReport): Promise<ApiResponse<IReport>> => {
        const response = await fetchData(REPORT_ENDPOINTS.UPSERT, {
            method: "POST",
            headers: {
                Authorization: authToken(),
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data)
        }, 2);

        return response.json();
    },
    /**
     * Получение отчета по неделе и году
     * @param reportingWeek Номер недели
     * @param reportingYear Год
     * @param owner ID владельца (только для администратора)
     */
    fetchReports: async (reportingWeek: number,
                         reportingYear: number,
                         owner: string | null,
    ): Promise<ApiResponse<IReport>> => {
        let url = `${REPORT_ENDPOINTS.FETCH}?reportingWeek=${reportingWeek}&reportingYear=${reportingYear}`;
        if (owner) {
            url += `&owner=${owner}`;
        }

        const response = await fetchData(url, {
            method: "GET",
            headers: {
                Authorization: authToken(),
                "Content-Type": "application/json",
            }
        }, 2);

        return response.json();
    },

    fetchAllReportsForExcel: async (reportingWeek: number,
                         reportingYear: number,
    ): Promise<ApiResponse<IReport[]>> => {
        let url = `${REPORT_ENDPOINTS.FETCH_ALL_EXCEL}?reportingWeek=${reportingWeek}&reportingYear=${reportingYear}`;

        const response = await fetchData(url, {
            method: "GET",
            headers: {
                Authorization: authToken(),
                "Content-Type": "application/json",
            }
        }, 2);

        return response.json();
    },
    fetchReportsLogs: async (page: number, limit: number): Promise<ApiResponse<IReportLogsResponse>> => {

        let url = `${REPORT_ENDPOINTS.FETCH_LOGS}?page=${page}&limit=${limit}`;

        const response = await fetchData(url, {
            method: "GET",
            headers: {
                Authorization: authToken(),
                "Content-Type": "application/json",
            }
        }, 2);

        return response.json();
    },

    fetchChartData: async (owner: string, section:string, param:string): Promise<ApiResponse<IReportLogsResponse>> => {
        let url = `${REPORT_ENDPOINTS.FETCH_CHART_DATA}?owner=${owner}&section=${section}&param=${param}`;

        const response = await fetchData(url, {
            method: "GET",
            headers: {
                Authorization: authToken(),
                "Content-Type": "application/json",
            }
        }, 2);

        return response.json();
    },
    fetchPlanChartData: async (owner: string, section:string, param:string): Promise<ApiResponse<IReportLogsResponse>> => {
        let url = `${REPORT_ENDPOINTS.FETCH_PLAN_CHART_DATA}?owner=${owner}&section=${section}&param=${param}`;

        const response = await fetchData(url, {
            method: "GET",
            headers: {
                Authorization: authToken(),
                "Content-Type": "application/json",
            }
        }, 2);

        return response.json();
    }

}
